import { useQuery } from 'react-query';

import { useAPI } from '../../../hooks/useAPI';
import { useProcessIdParam } from './use-process-id-param';

interface Props {
    navigateRouteOnError: string;
}

export const useLoanApplicationsQuery = ({ navigateRouteOnError }: Props) => {
    const { Onescore } = useAPI();
    const processId = useProcessIdParam({ navigateRouteOnError });

    return useQuery(
        'loan applications',
        () => Onescore.getLoanData({ processId: processId || '' }),
        {
            enabled: !!processId,
        },
    );
};
